import React, { useState } from 'react'
import useSearch from '../../../context/search/useSearch'
import SearchFilter from './Components/SearchFilter'
import ClearAndApplyButton from './Components/ClearAndApplyButton'
import handleModalClose from '../../../util/handleModalClose'
import SearchSortBy from './SearchSortBy'

const SearchFilters: React.FC = (): JSX.Element => {

  const { inputEventHandlers, searchFilters, sortKey, markFiltersChanged, setFiltersChanged, productSearchResult } = useSearch()
  const [pendingSortKey, setPendingSortKey] = useState(sortKey)

  // Prevent markFiltersChanged on initial mount
  const isFirstRender = React.useRef(true);

  // Don't show filters if there are no results
  if (!productSearchResult || productSearchResult.total === 0) {
    return null;
  }

  // Wrap setPendingSortKey to also mark filters changed if the sort changes, but not on first render
  const handleSetPendingSortKey = (key: string) => {
    setPendingSortKey(key)
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (key !== sortKey) {
      markFiltersChanged()
    }
  }

  return (
    <>
      <div className={'filter__container'}>
        <SearchSortBy pendingSortKey={pendingSortKey} setPendingSortKey={handleSetPendingSortKey} />
        {!searchFilters && <div>Loading Filters...</div>}
        {searchFilters && <>
          {searchFilters.map((filter, index) => {
            if (filter.options.length > 0) {
              return (<SearchFilter
                key={index}
                index={index}
                filter={filter}
              />)
            }
            return null
          })}
        </>}
      </div>
      <div className="filter__clear-apply">
        <ClearAndApplyButton
          showClear={true}
          showApply={true}
          afterClear={() => {
            inputEventHandlers.handleClearAllFilters();
            inputEventHandlers.handleApply();
            setFiltersChanged(false);
            handleModalClose(['filters-open']);
          }}
          afterApply={() => {
            if (pendingSortKey !== sortKey) {
              inputEventHandlers.handleSortByChange(pendingSortKey)
            }
            inputEventHandlers.handleApply();
            setFiltersChanged(false);
            handleModalClose(['filters-open']);
          }}
        />
      </div>
    </>
  )
}

export default SearchFilters